module.exports = __webpack_public_path__ + "static/TANMEMORIES-Regular-9619493c96a9be68c74c1ddd2f0493cd.ttf";